import emojiLibJson from "../lib/emojiLib.json";

const emojiParser = {
  getEmojiObjectByShortcode(shortcode) {
    const emojiLibJsonData = emojiLibJson;
    shortcode = shortcode.replace(/:/g, "");
    if (
      emojiLibJsonData[shortcode] &&
      typeof emojiLibJsonData[shortcode] === "object" &&
      emojiLibJsonData[shortcode].char
    ) {
      return emojiLibJsonData[shortcode];
    } else {
      const emojiUnicode = Object.keys(
        emojiLibJsonData
      ).find(emojiUnicodeItem =>
        emojiLibJsonData[emojiUnicodeItem].keyword === shortcode
      );
      if (emojiUnicode) {
        return emojiLibJsonData[emojiUnicode];
      }
    }
    return undefined;
  },
  parseToUnicode(text) {
    const emojisRegExp = /:(\w+):/g;
    const emojisShortcodesList = text.match(emojisRegExp);
    if (emojisShortcodesList) {
      emojisShortcodesList.forEach(shortcode => {
        const emoji = this.getEmojiObjectByShortcode(shortcode);
        if (emoji) {
          const regEx = new RegExp(shortcode);
          text = text.replace(regEx, emoji.char);
        }
      });
    }
    return text;
  }
};

export default emojiParser;



// WEBPACK FOOTER //
// ./resources/js/plugins/emojiParser.js